





































import Vue from "vue";
import IconArrowLeft from "@/components/icons/IconArrowLeft.vue";
import IconArrowRight from "@/components/icons/IconArrowRight.vue";
import Dot from "./Dot.vue";

export default Vue.extend({
  name: "SliderControls",
  components: {
    IconArrowLeft,
    IconArrowRight,
    Dot,
  },
  props: {
    steps: { type: Array, default: () => null },
    current: { type: Number, default: 0 },
    nav: { type: Function, default: () => null },
    set: { type: Function, default: () => null },
    timer: { type: Number, default: 0 },
  },
  computed: {
    curr(): number {
      return this.current % this.steps.length;
    },
    page(): number {
      return Math.floor(this.current / this.steps.length);
    },
  },
  methods: {},
});
